import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
export default {
  name: "addModalCode",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      formModel: {
        filename: null
      },
      formRules: {
        filename: [{
          required: true,
          type: 'object',
          message: this._vm.$t('dictmenu.uploadPlaceHolder'),
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {}
  },
  components: {},
  computed: {// getModalCode(){
    //   console.log(this._vm.$store.state.product.ModelCode);
    //   //
    //   return this._vm.$store.state.product.ModelCode
    // }
  },
  methods: {
    handleUpload: function handleUpload(file) {
      if (file.name.indexOf('.xls') > -1 || file.name.indexOf('.xlsx') > -1) {
        this.$set(this.formModel, 'filename', file);
      } else {
        this.$Message.error(this._vm.$t('dictmenu.uploadPlaceHolderType'));
      }

      return false;
    }
  },
  mounted: function mounted() {},
  created: function created() {// if (this.setData != undefined) {
    //   Object.assign(this.formModel,this.setData);
    // }
    // if(!this.edit){
    //   this.$set(this.formModel,'model_code',this.model_code)
    // }
  }
};